import green from '@material-ui/core/colors/green'
import red from '@material-ui/core/colors/red'

const styles = theme => ({
  rootContainer: {
    flexGrow: 1,
    zIndex: 1,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%'
  },
  logo: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  container: {
    maxWidth: '800px',
    margin: 'auto',
    marginTop: '40px'
  },
  accountContainer: {
    maxWidth: '800px',
    margin: 'auto',
    marginTop: '60px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '20px'
    }
  },
  content: {
    borderRadius: '0',
    padding: '16px 24px',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 16px'
    },
    '& a': {
      color: theme.palette.primary.main
    }
  },
  topNavContent: {
    maxWidth: '1600px',
    margin: 'auto',
    padding: '16px 24px',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 0px'
    }
  },
  wideDialogContent: {
    width: '100%',
    maxWidth: 1200,
    [theme.breakpoints.down('xs')]: {
      margin: '8px'
    }
  },
  dialogContent: {
    width: '100%',
    maxWidth: 700,
    [theme.breakpoints.down('xs')]: {
      margin: '8px'
    }
  },
  dialogHeaderContent:{
    display: 'flex',
    justifyContent: 'space-between'
  },
  dialogTitleDeleteBtn: {
    display: 'flex',
    backgroundColor: 'red',
    color: '#fff'
  },
  spacer: {
    marginTop: '10px'
  },
  root: {
    padding: 0,
    'label + &': {
      marginTop: theme.spacing.unit * 3
    }
  },
  input: {
    borderRadius: 2,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    fontSize: 16,
    lineHeight: '20px',
    padding: '10px 12px',
    width: 'calc(100% - 24px)',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(','),
    '&[aria-invalid=false]:focus': {
      borderColor: theme.palette.primary.main,
      boxShadow: '0 0 0 0.1rem rgba(46,125,50,.25)'
    },
    '&[aria-invalid=true]:focus': {
      borderColor: theme.palette.secondary.main,
      boxShadow: '0 0 0 0.1rem rgba(46,125,50,.25)'
    }
  },
  formLabel: {
    fontSize: 18,
    fontWeight: 'bold'
  },
  textRow: {
    textAlign: 'center',
    marginBottom: '30px'
  },
  flexRow: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'stretch'
  },
  buttonRow: {
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  themeLink: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  flexItemLeft: {
    flex: '1 1 auto',
    marginTop: '10px',
    marginRight: '5px',
    [theme.breakpoints.down('xs')]: {
      marginRight: '0',
      minWidth: '100%'
    }
  },
  flexItemLeftSmall: {
    maxWidth: '160px',
    flex: '1 1 auto',
    marginTop: '10px',
    marginRight: '5px',
    [theme.breakpoints.down('xs')]: {
      marginRight: '0',
      maxWidth: '100%'
    }
  },
  flexItemRight: {
    flex: '1 1 auto',
    marginTop: '10px',
    marginLeft: '5px',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '0',
      minWidth: '100%'
    }
  },
  flexItemMiddle: {
    flex: '1 1 auto',
    marginTop: '10px',
    marginLeft: '3px',
    marginRight: '3px',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '0',
      marginRight: '0',
      minWidth: '100%'
    }
  },
  flexGridItem: {
    flex: '1 1 auto',
    maxWidth: '300px',
    padding: '16px 24px',
    marginBottom: '10px'
  },
  flexGridItemMiddle: {
    flex: '1 1 auto',
    maxWidth: '300px',
    marginLeft: '5px',
    marginRight: '5px',
    padding: '8px 16px',
    marginBottom: '10px'
  },
  bar: {},
  checked: {
    color: `${theme.palette.primary.main} !important`,
    '& + $bar': {
      backgroundColor: `${theme.palette.primary.main} !important`
    }
  },
  menu: {
    padding: 10
  },
  wrapper: {
    maxHeight: '500px',
    overflowY: 'auto'
  },
  warning: {
    backgroundColor: 'red !important'
  },
  warningText: {
    color: 'red'
  },
  graph: {
    marginTop: '20px',
    padding: '16px 6px',
    justifyContent: 'center'
  },
  chart: {
    marginBottom: '30px'
  },
  chartLegends: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  chartContainer: {
    display: 'flex'
  },
  // chartWrapper (dateLength) {
  //   return { width: `${dateLength * 100}px` }
  // },
  chartSrollWrapper: {
    // width: '600px',
    overflow: 'auto',
    direction: 'rtl',
    width: '100%',
    margin: '0 auto'
  },
  rightIcon: {
    display: 'flex',
    maxHeight: '2em',
    alignItems: 'center',
    position: 'absolute',
    right: 0,
    bottom: '3px'
  },
  popper: {
    fontSize: '0.825rem'
  },
  /* This section contain subscription card styles */
  cardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginBottom: '20px',
    padding: '16px 24px',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  subscriptionCard: {
    flex: '1 1 auto',
    maxWidth: '600px',
    width: '100%',
    height: '100%',
    marginBottom: '20px',
    marginLeft: '10px',
    marginRight: '10px',
    [theme.breakpoints.down('1605')]: {
      margin: 'auto',
      marginBottom: '20px'
    }
  },
  media: {
    maxHeight: '300px',
    marginTop: '20px'
  },
  header: {
    display: 'flex'
  },
  headerTitle: {
    flex: '1 1 auto',
    marginLeft: '16px',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '0px'
    }
  },
  headerAction: {
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: '-8px',
    marginRight: '-16px'
  },
  headerTitleSub: {
    color: 'rgba(0, 0, 0, 0.54)',
    lineHeight: 'inherit'
  },
  cardContent: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: '16px'
  },
  avatarActive: {
    backgroundColor: green[800],
    [theme.breakpoints.down('xs')]: {
      marginRight: '10px'
    }
  },
  avatarPaused: {
    backgroundColor: red[800],
    [theme.breakpoints.down('xs')]: {
      marginRight: '10px'
    }
  },
  helperText: {
    marginLeft: '10px',
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  subSummary: {
    marginTop: '30px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    textAlign: 'center'
  },
  subSummaryItem: {
    flex: '1 1 auto'
  },
  tableWrapper: {
    width: '100%',
    overflowX: 'auto'
  },
  /* table toolbar styles */
  searchBar: {
    padding: '10px 24px'
  },
  highlight: {
    color: '#fff',
    backgroundColor: 'red',
    opacity: '0.8'
  },
  toolbarSpacer: {
    flex: '1 1 100%'
  },
  actions: {
    color: theme.palette.text.secondary,
    paddingRight: 20,
    flex: '1 0 auto'
  },
  title: {
    flex: '1 0 auto',
    marginLeft: '16px',
    color: '#000'
  },
  button: {
    margin: theme.spacing.unit
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  /* AutoComplete */
  suggestionsContainer: {
    flexGrow: 1,
    position: 'relative'
    // marginBottom: theme.spacing.unit * 3
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 3,
    left: 0,
    right: 0,
    background: '#fff',
    zIndex: 1
  },
  noAbsoluteSuggestionsContainerOpen: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 3,
    left: 0,
    right: 0,
    background: '#fff',
    zIndex: 1
  },
  suggestion: {
    display: 'block',
    height: 'auto'
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  },
  /* Switch */
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869'
      }
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp
    })
  },
  iOSChecked: {
    transform: 'translateX(23px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none'
    }
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 20,
    marginTop: -10,
    marginLeft: -18,
    backgroundColor: '#f94f4f',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  },
  iOSIcon: {
    width: 18,
    height: 18,
    marginRight: 2
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1]
  },
  /* Card styles */
  imageContainer: {
    marginLeft: '40px',
    marginRight: '40px',
    minHeight: '280px',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '20px',
      marginRight: '20px'
    }
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  col: {
    padding: 0,
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  colInside: {
    flex: '1',
    display: 'flex',
    margin: '0 10px',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      margin: 0
    }
  },
  /* Graph loading */
  chartSvg: {
    background: 'white',
    width: '500px',
    height: '100px',
    borderLeft: '1px solid #d9d9d9',
    borderBottom: '1px solid #d9d9d9',
    padding: '20px 20px 20px 0'
  },
  chartSvgData: {
    fill: '#d9d9d9',
    strokeWidth: '1'
  },


  // React Alert box.
  reactConfirmButtonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '20px'
  },
  reactConfirmButtonGroupBtnWarning: {
    outline: 'none',
    background: '#ff3333',
    border: 'none',
    display: 'inline-block',
    padding: '6px 18px',
    color: '#eee',
    marginRight: '10px',
    fornSize: '12px',
    cursor: 'pointer',
    borderRadius: '5px' 
  },

  reactConfirmButtonGroupBtnConfirm: {
    outline: 'none',
    background: '#4caf50',
    border: 'none',
    display: 'inline-block',
    padding: '6px 18px',
    color: '#eee',
    marginRight: '10px',
    fornSize: '12px',
    cursor: 'pointer',
    borderRadius: '5px'
  },

  reactConfirmButtonGroupBtnNeutral: {
    outline: 'none',
    background: '#6d7273',
    border: 'none',
    display: 'inline-block',
    padding: '6px 18px',
    color: '#eee',
    marginRight: '10px',
    fornSize: '12px',
    cursor: 'pointer',
    borderRadius: '5px'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/common/styles.js